import { useTranslation } from "react-i18next";

import { CalciteButton } from "@esri/calcite-components-react";
import "@esri/calcite-components/dist/components/calcite-button";
import { useAuth } from "./AuthProvider";
import { EsriUKLogo } from "./EsriUKLogo";

import { ReactElement } from "react";

export default function Header({
    portalUrl,
    user
}: {
    portalUrl: string;
    user?: any;
}): ReactElement {
    // Authentication
    const { appAuthId, signOut } = useAuth();

    const { t } = useTranslation("common");
    const oAuthUrl: string = `${portalUrl}/oauth2/authorize?client_id=${appAuthId}&response_type=token&redirect_uri=${encodeURIComponent(
        window.location.href
    )}`;
    return (
        <nav className="bg-white border-b border-gray-200 w-100 px-8 md:px-auto">
            <div className="max-w-screen-xl mx-auto h-16 mx-auto md:px-4 container flex items-center justify-between flex-wrap md:flex-nowrap">
                <div className="text-indigo-500 md:order-1">
                    <EsriUKLogo />
                </div>
                <div className="md:order-2 ml-auto">
                    {(user === undefined || user === null) && appAuthId !== undefined && (
                        <CalciteButton kind="neutral" appearance="outline-fill" href={oAuthUrl}>
                            <>{t("common.signin")}</>
                        </CalciteButton>
                    )}
                    {user !== undefined && user !== null && (
                        <CalciteButton
                            kind="neutral"
                            appearance="outline-fill"
                            href={window.location.pathname}
                            onClick={signOut}
                        >
                            <>{t("common.signout")}</>
                        </CalciteButton>
                    )}
                </div>
            </div>
        </nav>
    );
}
